import type { CityConfig } from "@/pages/city-template/types";

export const albanyOrConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Oregon Vital Records", href: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/", description: "Official Oregon vital records office in Portland" },
    { label: "Marriage Licenses — Linn County Clerk", href: "https://www.co.linn.or.us/clerk/", description: "Linn County Clerk — marriage license issuance" },
    { label: "Divorce Records — Linn County Clerk", href: "https://www.co.linn.or.us/clerk/", description: "Linn County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Oregon Vital Records for online vital record orders" },
  ],
  city: "Albany",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "albany-or",
  route: "/albany-or",
  title: "Emergency Passport Albany OR | Expedited Passport Linn County Oregon",
  metaDescription: "Emergency passport and expedited passport services in Albany, OR — as fast as 24 hours. Fast Passport Center serves Albany, Linn County, Corvallis, Lebanon, Sweet Home, and the mid-Willamette Valley. Registered State Dept. courier. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Albany, Oregon",
  heroSubtitle: "Albany resident with an expiring passport and a trip booked? Linn County's passport acceptance options are limited — and the nearest regional agency is in Seattle, 4+ hours away. Fast Passport Center gets Albany residents expedited passports in as fast as 24 hours, entirely remotely. No Seattle drive. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Albany%20Oregon%20mid-Willamette%20Valley%20landscape%20with%20Calapooia%20River%20winding%20through%20the%20city%2C%20historic%20downtown%20brick%20buildings%20and%20Victorian%20homes%2C%20lush%20green%20agricultural%20fields%20and%20timber%20country%20in%20background%2C%20Cascade%20Mountain%20peaks%20visible%20on%20the%20eastern%20horizon%2C%20clear%20Pacific%20Northwest%20day%20with%20dramatic%20clouds%2C%20photorealistic%20Pacific%20Northwest%20city%20portrait%2C%20no%20text%20no%20people&width=1800&height=700&seq=albany-or-hero-01&orientation=landscape",
  heroImageAlt: "Albany Oregon Willamette Valley with Calapooia River and Cascade Mountain views",
  geoPosition: "44.6365;-123.1059",
  geoPlacename: "Albany, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 260 miles north — approximately 4 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Albany", zips: "97321–97322" },
    { name: "Lebanon", zips: "97355" },
    { name: "Sweet Home", zips: "97386" },
    { name: "Corvallis", zips: "97330–97333" },
    { name: "Millersburg", zips: "97321" },
    { name: "Tangent", zips: "97389" },
    { name: "Jefferson", zips: "97352" },
    { name: "Halsey", zips: "97348" },
    { name: "Harrisburg", zips: "97446" },
    { name: "Junction City", zips: "97448" },
    { name: "Philomath", zips: "97370" },
    { name: "Salem", zips: "97301–97306" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Albany", desc: "Complete your emergency or expedited passport application from Albany — no drive to Seattle or Portland required." },
    { icon: "ri-truck-line", title: "Ship Overnight from Albany or Corvallis", desc: "FedEx Office and UPS locations in Albany and Corvallis serve the mid-Willamette Valley for overnight passport document shipping." },
    { icon: "ri-shield-check-line", title: "Professional Document Review", desc: "Every application reviewed before submission — essential for Linn County applicants far from regional passport agencies." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We submit through reserved Seattle Passport Agency channels — bypassing the public appointment wait." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Albany, OR",
      rating: 5,
      text: "Work trip to Canada came up on short notice and I'd completely forgotten my passport expired. Fast Passport Center renewed it in 6 days. Albany is far from any passport agency — this service saved me the trip to Seattle entirely.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Susan H.",
      location: "Albany, OR",
      rating: 5,
      text: "OSU family event — my daughter was studying abroad in Germany and we needed passports to visit. Three of us renewed through Fast Passport Center. All three back in 8 days. Shipped from the Albany FedEx on Pacific Boulevard. Exceptional.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Brian L.",
      location: "Lebanon, OR",
      rating: 5,
      text: "Agricultural trade mission to Japan — needed my passport renewed in 10 days. Fast Passport Center handled it in 7. Lebanon is rural and has almost no passport resources — this remote service is exactly what we needed.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "albany-post-main",
      name: "Albany Main Post Office",
      type: "USPS Passport Acceptance",
      address: "200 W 2nd Ave",
      city: "Albany",
      state: "OR",
      zip: "97321",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Downtown Albany — primary passport acceptance facility for Albany residents",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Albany residents. Appointment required — book in advance during peak summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "linn-county-clerk",
      name: "Linn County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "300 SW 4th Ave",
      city: "Albany",
      state: "OR",
      zip: "97321",
      phone: "(541) 967-3831",
      hours: "Mon–Fri 8am–5pm",
      distance: "Albany Linn County Courthouse — convenient downtown Albany option",
      website: "https://www.co.linn.or.us/clerk/",
      websiteLabel: "Linn County Clerk",
      notes: "Linn County Clerk accepts passport applications at the Albany courthouse. Often has better appointment availability than Albany Post Office.",
      icon: "ri-government-line",
    },
    {
      id: "albany-usps-2",
      name: "Albany NE Post Office",
      type: "USPS Passport Acceptance",
      address: "2680 Santiam Hwy SE",
      city: "Albany",
      state: "OR",
      zip: "97322",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "SE Albany — secondary passport acceptance option for east Albany and Millersburg residents",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "SE Albany post office — alternate option for east Albany residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lebanon-post",
      name: "Lebanon Post Office",
      type: "USPS Passport Acceptance",
      address: "445 S 5th St",
      city: "Lebanon",
      state: "OR",
      zip: "97355",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Lebanon — about 10 miles east of Albany on US-20",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Lebanon post office serves Lebanon, Sweet Home, and Santiam Canyon communities. Limited appointment availability — Albany or Corvallis recommended for urgent applications.",
      icon: "ri-mail-line",
    },
    {
      id: "corvallis-post-main",
      name: "Corvallis Main Post Office",
      type: "USPS Passport Acceptance",
      address: "311 SW 2nd St",
      city: "Corvallis",
      state: "OR",
      zip: "97333",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm, Sat 10am–2pm",
      distance: "Corvallis — about 10 miles southwest of Albany via US-20",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Corvallis Main Post Office is the best-staffed mid-Willamette Valley passport acceptance facility. Saturday hours available. Recommended when Albany appointments are backed up.",
      icon: "ri-mail-line",
    },
    {
      id: "benton-county-clerk",
      name: "Benton County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "120 NW 4th St",
      city: "Corvallis",
      state: "OR",
      zip: "97330",
      phone: "(541) 766-6800",
      hours: "Mon–Fri 8am–5pm",
      distance: "Corvallis — about 10 miles southwest of Albany",
      website: "https://www.co.benton.or.us/clerk",
      websiteLabel: "Benton County Clerk",
      notes: "Benton County Clerk in Corvallis accepts passport applications. Excellent option for Albany residents — good availability and convenient access from US-20.",
      icon: "ri-government-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Albany, Oregon?",
      a: "Yes. Fast Passport Center provides emergency passport processing for Albany, OR residents — as fast as 24 hours for life-or-death situations. The nearest passport agency is in Seattle (4 hours north). We serve Albany entirely remotely: start online, ship overnight from Albany or Corvallis, we submit through reserved Seattle channels.",
    },
    {
      q: "How fast can I renew my passport from Albany, OR?",
      a: "Adult passport renewal from Albany is available in as little as 3 business days through Fast Passport Center. Most adult renewals are by mail — no in-person acceptance appointment required. Ship overnight from the Albany FedEx on Pacific Boulevard or the Corvallis FedEx Office.",
    },
    {
      q: "Where do Albany, OR residents go for passport acceptance appointments?",
      a: "Albany has two acceptance locations: the Main Post Office (200 W 2nd Ave) and the Linn County Clerk (300 SW 4th Ave). For better availability, the Corvallis Main Post Office (10 miles southwest) and Benton County Clerk are excellent options. The nearest passport agency is Seattle.",
    },
    {
      q: "Can I expedite a passport for a Canada trip from the mid-Willamette Valley?",
      a: "Yes. Canada trips — Vancouver BC, Whistler, Victoria, and the Gulf Islands — are among the most common international destinations for Albany area residents. Fast Passport Center handles expedited passport renewals in 3–9 business days from Albany.",
    },
    {
      q: "Does Albany, Oregon have a passport acceptance office?",
      a: "Albany has a USPS passport acceptance office at the Main Post Office and at the Linn County Clerk's office — both in downtown Albany. Corvallis (10 miles southwest) has the highest-capacity acceptance facility for the mid-Willamette Valley area.",
    },
    {
      q: "What airports do Albany, OR residents use for international travel?",
      a: "Albany residents typically drive to Portland International Airport (PDX), about 75 miles north — Oregon's primary international hub. Eugene Airport (EUG) is 35 miles south with regional connections. PDX offers direct service to Europe, Japan, Mexico, and Canada.",
    },
    {
      q: "Can Linn County agricultural workers get expedited passports?",
      a: "Yes. Albany is in the heart of Oregon's agricultural belt — wheat, grass seed, timber, and manufactured products are exported globally. Trade missions, agricultural conferences, and business travel to Japan, South Korea, Canada, and Europe are common. Fast Passport Center handles expedited business passports.",
    },
    {
      q: "How long does standard passport processing take from Albany, OR?",
      a: "Standard USPS mail processing from Albany runs 6–13 weeks during normal periods, and longer during spring/summer peak travel season. If your trip is within 10 weeks, expedited service through Fast Passport Center is strongly recommended.",
    },
    {
      q: "Can I renew my passport without visiting an office in Albany?",
      a: "Yes — most adult Albany residents renewing a passport (issued age 16+, within 15 years, not damaged) can renew entirely by mail. Start online at Fast Passport Center, ship overnight from Albany, and we handle the rest remotely.",
    },
    {
      q: "Can Oregon State University students get expedited passports through Albany?",
      a: "Yes. OSU is in Corvallis, 10 miles from Albany — and many OSU students and faculty live in Albany. Fast Passport Center serves the entire mid-Willamette Valley for expedited passports for study abroad programs, international research, and academic conferences.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Albany Geary St", address: "2750 Geary St SE, Albany, OR 97322", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Albany", address: "3400 Killdeer Ave SE, Albany, OR 97322", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Albany", address: "2200 14th Ave SE, Albany, OR 97322", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM", website: "https://www.fedex.com/" },
    { name: "Rite Aid — Albany", address: "1600 SE Pacific Blvd, Albany, OR 97322", hours: "Daily 8 AM – 10 PM", website: "https://www.riteaid.com/" },
    { name: "FedEx Office — Corvallis", address: "343 SW 2nd St, Corvallis, OR 97333", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM", website: "https://www.fedex.com/" },
    { name: "Walmart — Corvallis", address: "444 NW Elks Dr, Corvallis, OR 97330", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Corvallis", address: "345 NW Kings Blvd, Corvallis, OR 97330", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "Rite Aid — Lebanon", address: "1420 S Main St, Lebanon, OR 97355", hours: "Daily 8 AM – 10 PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Salem Lancaster", address: "1840 Lancaster Dr NE, Salem, OR 97305", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "Costco Photo Center — Salem", address: "3795 Commercial St SE, Salem, OR 97302", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    {
      name: "Albany Driver & Motor Vehicle Services",
      address: "1700 Geary St SE, Albany, OR 97322",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Albany DMV — driver licenses, REAL ID, and ID cards for Linn County residents.",
      featured: true,
    },
    {
      name: "Corvallis Driver & Motor Vehicle Services",
      address: "2200 NW 9th St, Corvallis, OR 97330",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Corvallis DMV — larger Benton County office, good alternative for Albany area residents.",
      featured: false,
    },
    {
      name: "Lebanon Driver & Motor Vehicle Services",
      address: "1460 S Main St, Lebanon, OR 97355",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Lebanon DMV — serves Lebanon, Sweet Home, and east Linn County communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international hub — about 75 miles north via I-5",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International Airport is the primary international departure hub for Albany area residents. PDX offers direct service to Amsterdam, London, Tokyo, Mexico City, Vancouver BC, and Reykjavik. A valid U.S. passport is required for all international departures.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
    {
      code: "EUG",
      name: "Eugene Airport",
      distance: "About 35 miles south via I-5",
      address: "28855 Lockheed Dr, Eugene, OR 97402",
      note: "Eugene Airport provides regional connections to Portland, San Francisco, Los Angeles, Denver, and Seattle for onward international flights — closer to Albany than PDX.",
      flightUrl: "https://www.eugene-or.gov/airport",
      flightLabel: "Eugene Airport Website",
      featured: false,
    },
    {
      code: "SLE",
      name: "Salem Airport",
      distance: "About 20 miles north via I-5",
      address: "2890 25th St SE, Salem, OR 97302",
      note: "Salem Airport offers limited regional service — primarily general aviation. Most Albany residents fly commercial from PDX or EUG.",
      flightUrl: "https://salemail.com/",
      flightLabel: "Salem Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Albany & Linn County",
      description: "Last-minute international trip? Family emergency abroad? Fast Passport Center handles emergency passport processing for Albany residents — as fast as 24 hours. Seattle is 4 hours away; we serve you remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent and live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal — Albany, OR",
      description: "Passport expired during years of Willamette Valley living? Albany residents renew fast — ship from Albany overnight, we submit through reserved agency access and return your passport in days.",
      bullets: ["Fastest renewal option for Albany residents", "Ship overnight from Albany or Corvallis", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in Albany or before an international trip from PDX? We guide Linn County travelers through DS-64 and expedited replacement — no Seattle trip required.",
      bullets: ["DS-64 reporting guidance", "Expedited replacement timelines", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Albany Families",
      description: "Albany families heading to Canada, Mexico, or internationally need child passports. We guide you through the Linn County acceptance step — you handle the in-person visit, we expedite from there.",
      bullets: ["Both parents typically required to consent", "Albany Post Office or Linn County Clerk guidance", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First-time passport from Albany? We guide you through the Linn County Clerk or Albany Post Office acceptance step and handle expedited processing after.",
      bullets: ["Step-by-step acceptance guidance", "Photo location guide for Albany and Corvallis area", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — submitting through reserved agency channels at prices 30–100% lower than retail expediting services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Passport Services",
      description: "Name change after marriage, damaged passport replacement, second passports for Albany area agricultural exporters, educators, and business travelers — all with expedited courier access.",
      bullets: ["Name change passports", "Damaged passport replacement", "Second passport for frequent business travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Albany, Oregon travelers with urgent international departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Albany and Linn County residents needing passports faster than standard USPS timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Albany, Oregon residents — ship overnight from Albany or Corvallis, we handle the rest." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Albany travelers with lost or stolen passports before travel." },
    { name: "Child Passport", description: "Expedited child passport services for Albany and Linn County families traveling to Canada, Mexico, or internationally." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier serving Albany, Oregon and the mid-Willamette Valley area." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Until the Last Week Before Travel to Check Passport Validity", description: "Albany's mid-Willamette Valley community includes many agricultural workers, educators, and families who travel to Canada and Mexico seasonally. Many discover expired passports during packing. Check passport validity the day you book international travel." },
    { icon: "ri-camera-off-line", title: "Using an Improperly Formatted Passport Photo", description: "Passport photos from drug stores frequently have lighting or expression issues that cause government rejection. Fast Passport Center reviews photo compliance before submission." },
    { icon: "ri-file-damage-line", title: "Missing Signatures on Application Forms", description: "One missing signature causes application return — costing weeks. Our pre-submission review catches all form errors before submission to the agency." },
    { icon: "ri-pen-nib-line", title: "Submitting a Short-Form Birth Certificate", description: "Short-form or abstract birth certificates are typically rejected. We specify exactly which document format is required based on your state of birth." },
    { icon: "ri-map-pin-time-line", title: "Ignoring the Six-Month Validity Rule", description: "Canada (by air), Mexico, and most European countries require your passport to be valid for six months beyond your return date. A passport expiring in 3 months is functionally expired for most international trips." },
    { icon: "ri-calendar-close-line", title: "Applying Too Late for Seasonal Agricultural or Educational Travel", description: "Albany area agricultural trade missions to Japan, South Korea, and Canada — and OSU study abroad programs — have strict document deadlines. Start the passport process the moment your travel or program is confirmed." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Albany travel date. Complete your secure order from home." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist with Albany and Linn County area acceptance location guidance." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Albany or Corvallis", description: "Drop off at FedEx or UPS in Albany or Corvallis — both serve the mid-Willamette Valley with overnight shipping." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — no waiting for public appointment cancellations." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped Directly to Albany", description: "Your completed passport ships to your Albany or Linn County address. Track status in real time." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship from Albany or Corvallis overnight",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 4 hours each way",
        "Life-or-death emergencies only",
        "Very limited appointment availability",
        "Not practical for most Albany residents",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks during normal periods",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent or tracking",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited Seattle slots, weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (4 hours each way from Albany)", fpc: "Ship overnight from Albany or Corvallis" },
    { feature: "Processing Speed", agency: "Strict eligibility — urgent travel only", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Mid-Valley Accessibility", agency: "Not designed for Albany/Linn County residents", fpc: "Fully remote — ship from Albany or Corvallis" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 8-hour Seattle round trip cost", fpc: "Best price guarantee — no travel cost" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Corvallis", route: "/corvallis" },
    { name: "Emergency passport help in Salem", route: "/salem" },
    { name: "Fast passport renewal in Eugene", route: "/eugene" },
    { name: "Rush passport services in Springfield", route: "/springfield-or" },
    { name: "Expedited passports for Oregon travelers", route: "/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from FedEx or UPS in Albany or Corvallis. No office visit required for most services.",
  fpcOfficeDistance: "Serving Albany and the entire mid-Willamette Valley area remotely",
  serviceAreaIntro: "Whether you're in Albany, Lebanon, Sweet Home, Corvallis, or anywhere in Linn and Benton County — Fast Passport Center provides emergency and expedited passport processing without the 4-hour drive to Seattle.",
  nearbyCitiesIntro: "We serve all Linn County zip codes including Albany, Lebanon, Sweet Home, Harrisburg, Halsey, Tangent, and Millersburg — plus Benton County cities including Corvallis and Philomath.",
  howItWorksIntro: "Getting an emergency or expedited passport from Albany is simpler than a 4-hour drive to Seattle. Most Linn County clients complete the process without visiting an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Albany and Linn County passport applicants. Our review process prevents all of them.",
  testimonialsIntro: "Real reviews from Albany, Lebanon, and mid-Willamette Valley travelers who needed their passports fast.",
  faqIntro: "The most common questions Albany and Linn County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel & Passport Timing for Albany and Linn County Residents",
    intro: "Albany is Oregon's agricultural powerhouse — the heart of the Willamette Valley's grass seed, wheat, and timber economy. The city is positioned between Corvallis (Oregon State University) and Salem (the state capital), creating a mix of agricultural business travel, academic travel, and family international trips that drive passport urgency.",
    cards: [
      {
        icon: "ri-plant-line",
        title: "Agricultural Trade & Business Travel to Pacific Rim",
        subtitle: "Oregon grass seed, wheat, and timber industry exports to Japan, South Korea, Canada, and Europe",
        description: "Albany and Linn County are at the center of Oregon's grass seed industry — one of the largest in the world — plus wheat, timber, and manufactured products. Agricultural exporters, trade show attendees, and industry representatives regularly travel to Japan, South Korea, the Netherlands, and Canada for business. These trips are often scheduled around planting, harvest, or trade show calendars — with passport urgency peaking in March–April (spring trade shows) and October–November (fall harvest season).",
        tip: "Agricultural trade trip to Japan or South Korea? Albany exporters should check passport validity when the trade show or buyer visit is confirmed — not two weeks before departure. Many Japanese agricultural trade missions require visa applications that need a valid passport months in advance.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Oregon State University Academic Travel & Study Abroad",
        subtitle: "OSU Corvallis is 10 miles from Albany — OSU students and faculty live throughout Linn County",
        description: "Oregon State University in Corvallis is one of the Pacific Northwest's premier research universities — with extensive study abroad programs, international research partnerships, and faculty exchanges. Many OSU students and faculty live in Albany due to lower housing costs. OSU study abroad programs have strict passport submission deadlines months before departure — and visa requirements for many Asian, European, and Latin American programs.",
        tip: "OSU students: study abroad passport deadlines are often 4–6 months before departure. If you're admitted to a program, check your passport that same week. Don't wait for the program's document checklist to arrive — start now.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "Canada & British Columbia Travel from the Mid-Willamette Valley",
        subtitle: "Vancouver BC, Whistler, Victoria, and the Gulf Islands are top Albany area destinations",
        description: "British Columbia is the most common international destination for Albany and Linn County residents. Vancouver BC offers city travel, the Gulf Islands and Sunshine Coast for outdoor adventures, Whistler for skiing, and Victoria for heritage tourism. Land border crossings to British Columbia require a valid passport or enhanced driver's license — and air travel requires a passport. Albany families, outdoor enthusiasts, and agricultural workers cross into BC regularly.",
        tip: "BC summer travel books in February and March. Albany residents should confirm passport validity at booking — passports need to be valid for the duration of your stay. Many residents are surprised to find passports expired during pandemic travel restrictions.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Portland International Airport (PDX) Access from Albany",
        subtitle: "Albany is 75 miles south of PDX — a 70-minute drive to Oregon's primary international hub",
        description: "Portland International Airport (PDX) is Albany residents' primary international departure hub — about 75 miles north via I-5. PDX offers direct international service to Amsterdam, London, Tokyo, Reykjavik, Mexico City, and Vancouver BC. For shorter trips, Eugene Airport (35 miles south) provides convenient regional connections to PDX, SFO, LAX, and DEN. Albany residents planning international trips from PDX need a valid U.S. passport.",
        tip: "If flying internationally from PDX, add the 75-mile Albany-to-Portland drive to your pre-trip planning. Most Albany residents depart early morning — confirm passport validity when booking flights so you have time to expedite if needed.",
      },
    ],
    callout: {
      icon: "ri-landscape-line",
      title: "Albany, Oregon — The Willamette Valley's Agricultural Heart",
      description: "Albany sits at the confluence of the Willamette and Calapooia Rivers — Oregon's most productive agricultural county. The grass seed, timber, and manufacturing industries connect Albany to Pacific Rim trading partners. OSU Corvallis 10 miles away adds an academic international dimension. Fast Passport Center serves Albany and Linn County residents with the same expedited passport expertise as Portland-area residents — without requiring a drive to the big city.",
    },
  },
  destinations: {
    title: "Where Albany Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations we see most from Albany and Linn County clients. The combination of agricultural trade travel, OSU academic connections, family Canada trips, and winter Mexico escapes creates a diverse set of passport urgency situations.",
    stats: [
      { stat: "260 mi", label: "to Seattle Passport Agency — the nearest regional office from Albany" },
      { stat: "75 mi", label: "to Portland International Airport (PDX) — primary international hub for Albany" },
      { stat: "#1 Grass Seed", label: "Oregon is the world's top grass seed producer — Albany at center of export trade" },
      { stat: "2–9 Days", label: "fastest expedited passport processing available for Albany residents" },
    ],
    destinations: [
      { name: "British Columbia, Canada", context: "Vancouver BC, Whistler skiing, Victoria heritage travel, Gulf Islands — top destination for Albany and Linn County residents", urgency: "BC summer bookings in Feb–March; passport issues discovered when planning summer itineraries", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Agricultural trade missions, technology conferences, and cultural travel from Oregon's grass seed and timber industry", urgency: "Trade show and agricultural conference registrations; visa applications require valid passport months before departure", icon: "ri-global-line" },
      { name: "Mexico — Cabo, Puerto Vallarta, Riviera Maya", context: "Winter and spring escape travel for Albany families and agricultural community — November through April beach destinations", urgency: "October–November Mexico bookings; passports found expired during document gathering before January departure", icon: "ri-sun-cloudy-line" },
      { name: "Costa Rica & Central America", context: "Eco-adventure travel for Willamette Valley outdoor community — Arenal, Manuel Antonio, Monteverde", urgency: "Dry season travel (December–April) booked in fall; passport expiration discovered at booking time", icon: "ri-leaf-line" },
      { name: "Europe — Netherlands, Germany, France", context: "Agricultural trade shows (GreenTech Amsterdam, Agritechnica Hanover) and heritage travel for Albany's European-heritage community", urgency: "Trade show registrations and heritage travel planned months ahead — passport issues discovered at registration", icon: "ri-building-2-line" },
      { name: "Alaska Cruises from Seattle", context: "Inside Passage cruises departing Seattle are popular with Willamette Valley families — passports required for Alaska cruises stopping in Canada", urgency: "Spring cruise bookings in January–February; passports discovered expired when gathering boarding documents in April", icon: "ri-ship-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout the Willamette Valley with the same expedited passport expertise.",
    crossLinks: [
      { name: "Corvallis", route: "/corvallis" },
      { name: "Salem", route: "/salem" },
      { name: "Eugene", route: "/eugene" },
    ],
  },
};